import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_cash_stmt_hdr_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    guid_cashbook: fromDatatype.GuidDataFieldInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    date_start: fromDatatype.TimestampTzDatatypeInterface;
    date_end: fromDatatype.TimestampTzDatatypeInterface;
    amount_start_debit: fromDatatype.NumericDatatypeInterface;
    amount_start_credit: fromDatatype.NumericDatatypeInterface;
    amount_end_debit: fromDatatype.NumericDatatypeInterface;
    amount_end_credit: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;  
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}


export class bl_fi_cash_stmt_hdr_RowClass implements bl_fi_cash_stmt_hdr_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    bank_recon_hdr_guid:fromDatatype.GuidDataFieldInterface;
    guid_cashbook: fromDatatype.GuidDataFieldInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.TextDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    date_start: fromDatatype.TimestampTzDatatypeInterface;
    date_end: fromDatatype.TimestampTzDatatypeInterface;
    amount_start_debit: fromDatatype.NumericDatatypeInterface;
    amount_start_credit: fromDatatype.NumericDatatypeInterface;
    amount_end_debit: fromDatatype.NumericDatatypeInterface;
    amount_end_credit: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;  
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}